import { Injectable } from '@angular/core';


@Injectable()
export class ClientStorageService {

  get claims() {

    return this.getObject<{ [resource: string]: string }>('claims');
  }
  
  set claims(value: { [resource: string]: string }) {        
    this.claimsLastUpdated =new Date();
    this.setObject('claims', value);

    // console.log(`ClientStorageService.set_claims: ${JSON.stringify(value)}`);    
  }

  
  private _claimsLastUpdated : Date ;
  public get claimsLastUpdated() : Date  {
    return this._claimsLastUpdated;
  }
  public set claimsLastUpdated(v : Date ) {
    this._claimsLastUpdated = v;
  }
  

  get campaignTag(): string {
    return this.getString('campaignTag');
  }
  set campaignTag(value: string) {
    if (value === undefined) { return; }
    this.setString('campaignTag', value);
  }

  clear() {
    localStorage.clear();
  }

  private setObject(key: string, object) {
    localStorage.setItem(key, object === undefined ? '' : JSON.stringify(object));
  }

  private setString(key, value) {
    if (value === '') {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, value);
    }
  }

  private getObject<T>(key: string): T {
    const item = localStorage.getItem(key);
    
    //console.log('client-storage.service.getObject->' + item);

    return item ? <T>JSON.parse(item) : undefined;
  }

  private getString(key: string) {
    return key && localStorage.getItem(key) || undefined;
  }
}

